import withComponentName from '../../../../../decorators/withComponentName';

export function Support() {
  return (
    <p>
      The support provided by the Information Service Provider&nbsp;
      shall relate only to the Applications and API Infrastructure.&nbsp;
      Any problems which are related to Customer Computer Systems&nbsp;
      must be resolved by the Customer’s own support staff.&nbsp;
      <br />
      <br />
      Additional support services shall be available at additional&nbsp;
      cost to the Customer at the rates agreed by both parties
      <br />
      <br />
      When seeking support the Customer shall use its best and reasonable&nbsp;
      endeavours to provide the fullest information possible to aid the&nbsp;
      Information Service Provider in diagnosing any faults in either&nbsp;
      the Applications or the API Infrastructure.
      <br />
      <br />
      The Information Service Provider shall aim to resolve all support&nbsp;
      problems within 16 Business Hours or as soon as possible thereafter&nbsp;
      where resolution in that time is not possible.
      <br />
      <br />
      In the event of support problems, the Information Service Provider&nbsp;
      shall reasonably endeavour to provide a workaround solution to&nbsp;
      the Customer to enable the Customer’s continued use of the Services or to&nbsp;
      enable use that is as close to normal as is possible under the prevailing circumstances.
    </p>
  );
}

export default withComponentName(Support);
